import React, { PureComponent } from 'react';
import {
  Modal,
  Header,
  Button,
  Label,
  Dimmer,
  Loader
} from 'semantic-ui-react';
import { toast } from 'react-toastify';
import AdBuilderAdPreview from './AdBuilderAdPreview';

class AdBuilderAdPreviewModal extends PureComponent {
  state = {
    qcApproved: null,
    proessing: false
  };

  componentDidMount() {
    const { adPrototypeEdit } = this.props;
    if (adPrototypeEdit && adPrototypeEdit.qc_approved !== undefined) {
      this.initQcApproved();
    }
  }

  componentDidUpdate(prevProps) {
    const { adPrototypeEdit: prevPrototype } = prevProps;
    const { adPrototypeEdit: currPrototype } = this.props;
    if (
      prevPrototype.qc_approved === undefined &&
      currPrototype.qc_approved !== undefined
    ) {
      this.initQcApproved();
    }
  }

  initQcApproved = () => {
    const { adPrototypeEdit } = this.props;
    const { qc_approved: qcApproved } = adPrototypeEdit;
    this.setState({ qcApproved });
  };

  toggleModal = () => {
    const { toggleAdBuilderAdPreviewModal } = this.props;
    if (toggleAdBuilderAdPreviewModal) {
      toggleAdBuilderAdPreviewModal();
    }
  };

  qcAdPrototype = (approvalBool = null) => {
    const { adPrototypeEdit, updateAdPrototypeForQc, inEditor } = this.props;
    const { qc_approved: originalQcApproved } = adPrototypeEdit || {};
    if (originalQcApproved !== undefined) {
      this.setState({ ...this.state, processing: true }, async () => {
        const newAdPrototype = { ...adPrototypeEdit };
        newAdPrototype.qc_approved = approvalBool;

        let updateResult = {};
        let actionText = approvalBool === null && 'qc cleared';
        let toastType = approvalBool === null && 'default';

        if (typeof approvalBool === 'boolean') {
          actionText = approvalBool ? 'approved' : 'denied';
          toastType = approvalBool ? 'success' : 'error';
        }

        if (inEditor) {
          updateAdPrototypeForQc(approvalBool);
          toast(`Ad Preview ${actionText}. Save changes for QC to Apply`, {
            position: 'top-right',
            autoClose: 4000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            type: toastType
          });
        } else {
          updateResult = await updateAdPrototypeForQc(
            newAdPrototype,
            approvalBool
          );
        }

        const { statusCode, adPrototypeId } = updateResult || {};
        this.setState((prevState) => ({
          ...prevState,
          qcApproved:
            (statusCode === 200 && adPrototypeId) || inEditor
              ? approvalBool
              : null,
          processing: false
        }));
      });
    }
  };

  render() {
    const {
      showAdBuilderAdPreviewModal,
      adPrototypeEdit,
      adType,
      pageId,
      getFbToken
    } = this.props;
    const { qcApproved, processing } = this.state;
    return (
      <Modal
        centered
        dimmer
        open={showAdBuilderAdPreviewModal}
        onClose={this.toggleModal}
        closeIcon
      >
        <Modal.Header>
          Ad Preview: <b>{adPrototypeEdit.name}</b>
          {typeof qcApproved === 'boolean' ? (
            <Label
              corner
              size="huge"
              color={qcApproved ? 'green' : 'red'}
              icon={qcApproved ? 'check circle outline' : 'dont'}
            />
          ) : (
            <Label corner size="huge" icon="circle outline" />
          )}
        </Modal.Header>
        <Modal.Content>
          <AdBuilderAdPreview
            adPrototypeEdit={adPrototypeEdit}
            adType={adType}
            pageId={pageId}
            getFbToken={getFbToken}
          />
        </Modal.Content>
        <Modal.Actions>
          <Dimmer.Dimmable dimmed={processing}>
            <Dimmer active={processing} inverted>
              <Loader size="tiny">Processing QC...</Loader>
            </Dimmer>
            <Header floated="left" style={{ paddingTop: '0.5em' }}>
              Preview QC
            </Header>
            <Button
              labelPosition="left"
              icon="erase"
              content="Clear"
              disabled={processing}
              onClick={() => this.qcAdPrototype(null)}
            />
            <Button
              negative
              labelPosition="left"
              icon="dont"
              content="Deny"
              disabled={processing}
              onClick={() => this.qcAdPrototype(false)}
            />
            <Button
              positive
              labelPosition="left"
              icon="check circle outline"
              content="Approve"
              disabled={processing}
              onClick={() => this.qcAdPrototype(true)}
            />
          </Dimmer.Dimmable>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default AdBuilderAdPreviewModal;



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/AdLibrary/AdBuilderAdPreviewModal.js